import styled from 'styled-components';
import BusinessInfoPopoverContent from './BusinessInfoPopoverContent';
import PopoverInfoBox from './PopoverInfoBox';
import ContactUsPopoverContent from './ContactUsPopoverContent';
import LastTicketPopoverContent from './LastTicketPopoverContent';
import PrintSummaryBill from 'features/report/pages/ReportPage/RevenueIncome/components/PrintSummaryBill';
import { useAppDispatch } from 'store/hooks';
import reportActions from 'features/report/services/actions';
import { ReportType } from 'features/report/pages/ReportPage/constants';
import moment from 'moment';
import { DATE_FORMAT } from 'features/appointment/utils/format';
import PermissionManager from 'widgets/PermissionVerify';
import { verifyAdminPW } from 'widgets/RequestAdminLocalPW/Callback';
import shopSelectors from 'services/shop/selectors';

const InfoBox = () => {
  const allSetting = shopSelectors.data.allSetting();
  return (
    <Container>
      <PopoverInfoBox content={<BusinessInfoPopoverContent />} buttonText='Business Info' />
      <PopoverInfoBox content={<ContactUsPopoverContent />} buttonText='Contact Us' />
      <PopoverInfoBox content={<LastTicketPopoverContent />} buttonText='Last Service Info' isLastTicket />
      {!!allSetting?.displaySummaryReportHome && <PrintSummaryRevenue />}
    </Container>
  );
};

export default InfoBox;

const Container = styled.div`
  background: transparent;
  position: absolute;
  bottom: 0;
  left: 0;
  display: flex;
`;

const PrintSummaryRevenue = () => {
  const dispatch = useAppDispatch();
  return <PrintSummaryBill renderButton={({ onClick }) => <PopoverInfoBox onClick={async () => {
    const cb = () => {
      dispatch(
        reportActions.setParams({
          [ReportType.REVENUE]: {
            startTime: moment().format(DATE_FORMAT),
            endTime: moment().format(DATE_FORMAT),
          },
        })
      );
      setTimeout(() => {
        onClick();
      }, 100);
    };
    const result = await PermissionManager.verify(PermissionManager.PERMISSIONS.REPORT_VIEW);
    if (result !== null) {
      if (!result || result?.skip) return cb();
      if (!result.verifyData) return;
      return cb();
    }
    verifyAdminPW(cb);
  }} buttonText='Print Summary' isLastTicket />} />;
};
